import { LinkItemSchema } from '@/views/sports/components/CompetitionsMenu/styles/LinkItem.styles';

export const linkItemStyles: LinkItemSchema = {
  link: {
    display: 'flex',
    justifyContent: 'space-between',
    py: '2',
    pl: '3',
    pr: '2',
    borderBottomWidth: '1px',
    borderBottomColor: 'white',
    _hover: {
      textDecoration: 'none',
    },
    _last: {
      border: 'none',
    },
  },
  textCompetitionName: {
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxW: '140px',
    fontSize: 'xs',
    fontWeight: 'medium',
  },
  textMatchCount: {
    color: 'white',
    px: '1',
    fontSize: '3xs',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
  },
};
